import React, { useEffect, useState } from "react";
import {
  collection,
  doc,
  addDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import Cookies from "js-cookie";
import { db } from "../firebase-config";
import { BiTimeFive } from "react-icons/bi";
import { GoChevronUp, GoPaperAirplane } from "react-icons/go";
import { useStateContext } from "../Context/ContextProvider";
const Chat = () => {
  const { messages } = useStateContext();
  const [myMsg, setMyMsg] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const updateRead = () => {
        try{
            const unReadMsg = messages.filter(
              (data) => (data.status = "unread" && data.name !== Cookies.get("name"))
            );
            if(unReadMsg.length > 0 && messages.length > 0){
                unReadMsg.map((data) =>
                  updateDoc(
                    doc(
                      db,
                      "room",
                      sessionStorage.getItem("roomCode"),
                      "messages",
                      data.id
                    ),
                    { status: "read" }
                  ).catch((err)=>console.log(err))
                );
            }
        }catch(err){
            console.log(err)
        }
    };
    updateRead();
  }, []);
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  const sendMsg = async () => {
    try{
      if(myMsg.trim() !== ""){
        await addDoc(
            collection(db, "room", sessionStorage.getItem("roomCode"), "messages"),
            {
              data: myMsg.trim(),
              sender: Cookies.get("name"),
              timestamp: Timestamp.now(),
              email: Cookies.get("email"),
              status: "unread",
            }
          )
            .then(() => {
              setMyMsg("");
            })
            .catch((err) => console.log(err));
      }
    }catch(err){
        console.log(err)
    }
   
  };
  return (
    <div className="bg-black pt-3 h-screen">
      <div className="text-white ml-5 text-xl flex items-end">
        <b>Chat</b>
      </div>
      <div className="flex  flex-col max-w-screen-sm">
        {sessionStorage.getItem("roomCode") ? (
          <div>
            <div className=" bg-zinc-900  h-[calc(100vh-40vh)] m-3  overflow-hidden overflow-y-scroll rounded-lg text-sm">
              <div className="flex flex-col justify-between w-[95vw] gap-0">
                {messages.map((data, index) =>
                  data.email === Cookies.get("email") ? (
                  (
                      <div
                        key={index}
                        className=" chat chat-end  text-white p-2 "
                      >
                        <div className="bg-black chat-bubble ">
                          <b>{"You"}</b>
                          <p>{data.data}</p>
                          <div className="flex flex-row items-center text-xs">
                            <BiTimeFive />{" "}
                            {data.timestamp.toDate().getHours() +
                              ":" +
                              data.timestamp.toDate().getMinutes()}
                          </div>
                        </div>
                      </div>
                    )
                  ) : (
                    <div
                      key={index}
                      className=" chat chat-start  text-white p-2 "
                    >
                      <div className="bg-black chat-bubble">
                        <b>{data.sender}</b>
                        <p>{data.data}</p>
                        <div className="flex flex-row items-center text-xs">
                          <BiTimeFive />{" "}
                          {data.timestamp.toDate().getHours() +
                            ":" +
                            data.timestamp.toDate().getMinutes()}
                        </div>
                      </div>
                    </div>
                  )
                )}
                <button
                  className={` bg-white bg-opacity-10 w-8 p-2  rounded-full backdrop-filter backdrop-blur fixed right-7 bottom-20 transition-opacity ${
                    isVisible ? "opacity-100" : "opacity-0"
                  }`}
                  onClick={() => scrollToElement("top")}
                >
                  <GoChevronUp className="mx-auto" color="white" size={15} />
                </button>
              </div>
            </div>
            <div className=" absolute ms-3 bottom-32">
              <div className="flex flex-row gap-2">
                <input
                  type="text"
                  className="bg-slate-50 h-10 w-[90%]   rounded-full pl-5  outline-none "
                  value={myMsg}
                  onChange={(e) => {
                    setMyMsg(e.target.value);
                  }}
                  placeholder="Type here..."
                />
                <button
                  className="bg-slate-50 rounded-full  p-2 w-10  text-center "
                  onClick={() => sendMsg()}
                >
                  {/* <Icon path={mdiSend} size={1} /> */}
                  <GoPaperAirplane
                    className="mx-auto"
                    color="black"
                    size={18}
                  />
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-14 mx-auto text-white">
            <p>
              <b>Please join the room to chat </b>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Chat;
